export default "__VITE_ASSET__DIV43EyV__"